import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {EditorDialog} from '../editor-components';
import CategorySelect from './category-select';

/** @class EditAffiliateDialog
  * A component for editing an existing affiliate.
  */
export default class EditAffiliateDialog extends Component {
  /** @constructor
    * Constructs a new EditAffiliateDialog instance
    */
  constructor(props) {
    super(props);
    this.state = {
      organization: props.affiliate.organization || '',
      group: props.affiliate.group || '',
      email: props.affiliate.email || '',
      phone: props.affiliate.phone || '',
      notes: props.affiliate.notes || '',
      token: props.affiliate.token
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }
  /** @method componentWillReceiveProps
    * Responds to changing props (most likely
    * when a new user has been selected).
    */
  componentWillReceiveProps(props) {
    this.setState({
      organization: props.affiliate.organization || '',
      group: props.affiliate.group || '',
      email: props.affiliate.email || '',
      phone: props.affiliate.phone || '',
      notes: props.affiliate.notes || '',
      token: props.affiliate.token
    });
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @method handleSelect
    * Applies changes to the user state from a select input
    * @param {InputEvent} event - the triggering event
    */
  handleSelect(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    firebase.database().ref(`/affiliates/${this.props.affiliate.id}/${name}`).set(value);
  }
  /** @function handleBlur
    * Applies the current state to the database
    */
  handleBlur(event) {
    const target = event.target;
    const name = target.name;
    firebase.database().ref(`/affiliates/${this.props.affiliate.id}/${name}`).set(this.state[name]);
  }
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <EditorDialog show={this.props.show} onExit={this.props.onExit}>
        <h3>Edit Affiliate</h3>
        <p className="info-panel">
          Changes are automatically applied
        </p>
        <div className="input-group">
          <label htmlFor="organization">Organization</label>
          <input name="organization" type="text"
            value={this.state.organization}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="group">Group</label>
          <input name="group" type="text"
            value={this.state.group}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="token">Token (cannot be changed)</label>
          <input name="token" type="token"
            value={this.state.token}
            readOnly={true}/>
        </div>
        <CategorySelect name="category"
          value={this.state.category}
          onChange={this.handleSelect}
          />
        <div className="input-group">
          <label htmlFor="contact">Contact Name</label>
          <input name="contact" type="text"
            value={this.state.contact}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="email">Contact Email</label>
          <input name="email" type="email"
            value={this.state.email}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="phone">Contact Phone</label>
          <input name="phone" type="phone"
            value={this.state.phone}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            pattern="[0-9]{3}[ -][0-9]{3}[ -][0-9]{4}"
            />
        </div>
        <div className="input-group">
          <label htmlFor="notes">Notes</label>
          <textarea name="notes"
            value={this.state.notes}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
      </EditorDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/affiliate-list/edit-affiliate-dialog.js